import React, {
  Component
} from 'react';

import * as Config from '../config/Config';
import * as User from '../helpers/User';
import * as Common from '../helpers/Common';

import GridTile from './grid_partials/GridTile';



export default class GridComp extends Component {

  constructor(props) {
    super(props);
    this.goToThanksPage = this.goToThanksPage.bind(this);
    this.state = {
     LearningCompletedStatus:null,
     gridData:[],
     gridComponentsData:[],
     timeForCompletion: 0,
     timerSeconds: 0
    };
  }

  getLearningCompletedStatus(){
    const {data}=this.props;
    Common.reactLoader("show", "Please wait...");

    let query_data=Common.objToSlashString({

     learner_id:User.UserId(),
     compseq_id:data.compseq_id,
     lroom_id:data.learning_room_id,
     dlr_id:data.dlr_id
    });

    fetch(Config.domainUrl+'learner-component-status/view'+query_data+'?expand=completed_date,Cscore', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization':'Bearer ' +Common.getTokenData()
      }
    }).then((response) => response.json()).then((responseJson) => {

     if(responseJson.status==1){

      this.setState({
       LearningCompletedStatus:responseJson.data
      });

     }

      Common.reactLoader("hide");
    });
  }

  getGrid(id){
    Common.reactLoader("show", "Please wait...");
   	fetch(Config.domainUrl+'girdcomponent/'+id+'?expand=components', {
     	method: 'GET',
     	headers: {
     		'Accept': 'application/json',
       	'Content-Type': 'application/json',
         'Authorization':'Bearer ' +Common.getTokenData()
     	}
   	}).then((response) => response.json()).then((responseJson) => {
      let grid=responseJson.data;
     this.setState({
      gridData:grid,
      gridComponentsData:grid.components,
      timeForCompletion:grid.total_duration,
      timerSeconds:(grid.total_duration* 60)
     });
     this.getLearningCompletedStatus();


     Common.composcroll();
      Common.contentResizeLoad();
     Common.showSmallLeftMenu();
    Common.reactLoader("hide");
    });
    }
    goToThanksPage() {
        const {
            data
        } = this.props;
        this.props.returnthanks({
            "status": "completed",
            "learning_room_id": data.learning_room_id,
            "compseq_id": data.compseq_id,
            "divider_id": data.divider_id,
            "dlr_id": data.dlr_id,
            "learner_id": data.learner_id,
            "is_ag": data.is_ag,
            "id": data.id,
            "compo_type": "thanks",
            "look_before": data.compseq_id,
            "flowresult": true
        });
    }


    backToList(){

     const {data}=this.props;
      this.props.switchback('component_list',data.learning_room_id,data.dlr_id);

    }


    componentDidMount() {

      const {data}=this.props;
      ///this.getCourseworkAnswer();
      this.getGrid(data.id);


    }

  render() {

   const {data,usableType}=this.props;
  	let gridData=this.state.gridData;

    return (
     <div className="main-inner">
     <div className="border-box">
       <div className={gridData.gridcomp_desc?"title-box":"title-box tit-new"}>
          <div title={gridData.alt_text?gridData.alt_text:''} className="gc_complete_button"></div>
          <h6>{gridData.gridcomp_name?gridData.gridcomp_name:''}</h6><span className="bluetxt">{gridData.gridcomp_desc?gridData.gridcomp_desc:""}</span>


          </div>
     <section className="scroll" id="semana-scroll-inner">

      <section className="viewport">
       <section className="overview" style={{top: '0px'}}>

        <div className="inner-content">


          <GridTile data={this.state.gridComponentsData} usableType={usableType} compData={data} learningCompletedStatus={this.state.LearningCompletedStatus} switchbackList={(e)=>this.backToList()} goToThanksPage={this.goToThanksPage} />


      </div>

     </section>
     </section>
     </section>

     </div>
     </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/lr_dlr_components/GridComp.js